// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1EHo0","footer":"ChangeClinic_footer__IN_wp"};